'use strict';

angular.module('shiftTraderApp')
  .directive('saNoteSubmit', [function() {
    return {
      restrict: 'A',
      require: "^saNoteCreate",
      template: '<div class="sa-note-submit"></div>',
      link: function(scope, element, attrs, parentCtrl) {
        var lastClick = null;
        $(element).on('click touchstart', function(e) {
          if (!lastClick || (Date.now() - lastClick > 1000)) {
            lastClick = Date.now();
            parentCtrl.submit();
          }
        });

        function setText(iconClass, text) {
          var markup = '<i class="'+iconClass+'"></i>';
          if (text) {
            markup += '<span>&ensp;' + text + '</span>';
          }
          $(element).children('div:first').html(markup);
        }

        var mode = parentCtrl.getMode();
        if (mode === 'reply') {
          $(element).find('.sa-note-submit').addClass('btn-only-icon');
          setText('icon-paper-plane');
        } else if (mode === 'edit') {
          $(element).find('.sa-note-submit').addClass('btn');
          setText('icon-arrow-up', 'Update');
        } else {
          $(element).find('.sa-note-submit').addClass('btn');
          setText('icon-paper-plane', 'Post');
        }
      }
    }
  }]);
